import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, unref as _unref, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "card h-lg-100" }
const _hoisted_3 = { class: "card-body d-flex justify-content-between align-items-start flex-column" }
const _hoisted_4 = { class: "d-flex flex-column my-7" }
const _hoisted_5 = { class: "fw-semibold fs-3x text-gray-800 lh-1 ls-n2" }
const _hoisted_6 = { class: "m-0" }
const _hoisted_7 = { class: "fw-semibold fs-6 text-gray-400" }
const _hoisted_8 = { class: "ms-2 fw-semibold fs-6 text-gray-400" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "card" }
const _hoisted_11 = { class: "card-header d-flex align-items-center justify-content-start" }
const _hoisted_12 = { class: "d-flex" }
const _hoisted_13 = { class: "ms-5 d-flex align-items-center" }
const _hoisted_14 = { class: "ms-5" }
const _hoisted_15 = { class: "ms-5" }
const _hoisted_16 = { class: "d-flex ms-5" }
const _hoisted_17 = { class: "card-body py-4" }
const _hoisted_18 = {
  class: "table align-middle table-row-dashed fs-6 gy-5",
  id: "table_accounts_requests"
}
const _hoisted_19 = { class: "text-start text-muted fw-bold fs-7 text-uppercase gs-0" }
const _hoisted_20 = { class: "" }
const _hoisted_21 = { class: "" }
const _hoisted_22 = { class: "" }
const _hoisted_23 = { class: "" }
const _hoisted_24 = { class: "" }
const _hoisted_25 = { class: "cell-color text-center" }
const _hoisted_26 = { key: 0 }
const _hoisted_27 = { key: 1 }
const _hoisted_28 = {
  key: 2,
  class: "fw-semibold text-gray-900"
}
const _hoisted_29 = { class: "d-flex align-items-center" }
const _hoisted_30 = { class: "text-center" }

import { computed, onMounted, ref } from "vue";
import PaymentService, {
  WalletStatisticViewModel,
} from "../services/PaymentService";
import TableFooter from "@/components/TableFooter.vue";
import MsgPrompt from "@/core/plugins/MsgPrompt";
import WalletExportModal from "@/projects/tenant/modules/Payment/modal/WalletExportModal.vue";
import { useI18n } from "vue-i18n";
import { FundTypes, getAllFundTypeSelections } from "@/core/types/FundTypes";
import WalletDetail from "@/projects/tenant/modules/users/components/modal/walletDetail.vue";
import CreateRefund from "../components/modal/CreateRefund.vue";
import ChangeWalletFundType from "../modal/ChangeWalletFundType.vue";
import { Wallet } from "@element-plus/icons-vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'WalletIndex',
  setup(__props) {

const isLoading = ref(false);
const isStatLoading = ref(false);
const wallets = ref([]);
const walletStat = ref(Array<WalletStatisticViewModel>());
const walletDetailRef = ref<InstanceType<typeof WalletDetail>>();
const createRefundRef = ref<InstanceType<typeof CreateRefund>>();
const changeWalletFundTypeRef =
  ref<InstanceType<typeof ChangeWalletFundType>>();
const walletExportModalRef = ref<any>(null);
const { t } = useI18n();
const selectedOption = ref("id");
const inputValue = ref("");
const criteria = ref({ hasBalance: true } as any);
const initCriteria = (c?: any) => {
  criteria.value = c ?? {
    ...criteria.value,
    page: 1,
    size: 20,
    sortField: "balance",
  };
};
initCriteria();
const fundTypeSelections = getAllFundTypeSelections([
  FundTypes.Wire,
  FundTypes.Ips,
]);

onMounted(async () => {
  isLoading.value = true;
  await fetchStat();
  await fetchData(1);
});

const openWalletExportModal = () => {
  walletExportModalRef.value?.show(criteria.value, currencySelections.value);
};

const viewWalletTransactions = (walletId: number, currencyId: number) => {
  walletDetailRef.value?.show(walletId, currencyId);
};

const showCreateRefund = (walletId: number) => {
  createRefundRef.value?.show(walletId);
};

const changeFundType = (item: any) => {
  changeWalletFundTypeRef.value?.show(item);
};
const onViewListClicked = (item) => {
  criteria.value.currencyId = item.currencyId;
  criteria.value.fundType = item.fundType;
  fetchData(1);
};

const reset = () => {
  criteria.value = { page: 1, size: 20, sortField: "balance" };
  inputValue.value = "";
  fetchData(1);
};

const search = () => {
  delete criteria.value.id;
  delete criteria.value.email;
  delete criteria.value.accountUid;
  criteria.value[selectedOption.value] = inputValue.value;
  fetchData(1);
};

const fetchData = async (_page: number) => {
  criteria.value.page = _page;
  try {
    isLoading.value = true;
    const result = await PaymentService.queryWallet(criteria.value);
    wallets.value = result.data;
    criteria.value = result.criteria;

    if (criteria.value.id == 0) criteria.value.id = null;
  } catch (e) {
    MsgPrompt.error(e);
  } finally {
    isLoading.value = false;
  }
};

const currencySelections = computed(() => {
  const currencyIds = [
    ...new Set(walletStat.value.map((item) => item.currencyId)),
  ];
  return currencyIds.map((item) => ({
    label: t(`type.currency.${item}`),
    value: item,
  }));
});

const fetchStat = async () => {
  isStatLoading.value = true;
  try {
    isStatLoading.value = true;
    walletStat.value = await PaymentService.queryWalletStatistic();
  } catch (e) {
    MsgPrompt.error(e);
  } finally {
    isStatLoading.value = false;
  }
};

return (_ctx: any,_cache: any) => {
  const _component_BalanceShow = _resolveComponent("BalanceShow")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_LoadingRing = _resolveComponent("LoadingRing")!
  const _component_NoDataBox = _resolveComponent("NoDataBox")!
  const _component_UserInfo = _resolveComponent("UserInfo")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(walletStat.value, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "col-sm-4 col-xl-3 mb-xl-10",
          key: index
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("span", _hoisted_5, [
                  _createVNode(_component_BalanceShow, {
                    "currency-id": item.currencyId,
                    balance: item.balance
                  }, null, 8, ["currency-id", "balance"])
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t("type.currency." + item.currencyId)), 1),
                  _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t(`type.fundType.${item.fundType}`)), 1),
                  _createElementVNode("span", {
                    class: "btn btn-sm cursor-pointer",
                    onClick: ($event: any) => (onViewListClicked(item))
                  }, _toDisplayString(_ctx.$t("action.viewList")), 9, _hoisted_9)
                ])
              ])
            ])
          ])
        ]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_el_checkbox, {
              modelValue: criteria.value.hasBalance,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((criteria.value.hasBalance) = $event)),
              class: "me-3",
              onChange: _cache[1] || (_cache[1] = ($event: any) => (fetchData(1))),
              disabled: isLoading.value
            }, {
              default: _withCtx(() => [
                _createTextVNode("Has Balance")
              ]),
              _: 1
            }, 8, ["modelValue", "disabled"]),
            _createVNode(_component_el_select, {
              modelValue: selectedOption.value,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((selectedOption).value = $event)),
              placeholder: "Select option",
              class: "w-150px me-3",
              disabled: isLoading.value
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_option, {
                  label: "Wallet ID",
                  value: "id"
                }),
                _createVNode(_component_el_option, {
                  label: "Email",
                  value: "email"
                }),
                _createVNode(_component_el_option, {
                  label: "Account UID",
                  value: "accountUid"
                })
              ]),
              _: 1
            }, 8, ["modelValue", "disabled"]),
            _createVNode(_component_el_input, {
              class: "w-200px",
              modelValue: inputValue.value,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((inputValue).value = $event)),
              disabled: isLoading.value
            }, null, 8, ["modelValue", "disabled"])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_component_el_select, {
              class: "w-125px",
              modelValue: criteria.value.currencyId,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((criteria.value.currencyId) = $event)),
              placeholder: _ctx.$t('fields.currency'),
              disabled: isLoading.value
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_option, {
                  label: "-- All --",
                  value: ""
                }),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currencySelections.value, (item) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: item.value,
                    label: item.label,
                    value: item.value
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue", "placeholder", "disabled"])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createVNode(_component_el_select, {
              class: "w-125px",
              modelValue: criteria.value.fundType,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((criteria.value.fundType) = $event)),
              placeholder: _ctx.$t('fields.fundType'),
              disabled: isLoading.value
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_option, {
                  label: "-- All --",
                  value: ""
                }),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(fundTypeSelections), (item) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: item.value,
                    label: item.label,
                    value: item.value
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue", "placeholder", "disabled"])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: search,
              plain: "",
              disabled: isLoading.value
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("action.search")), 1)
              ]),
              _: 1
            }, 8, ["disabled"]),
            _createVNode(_component_el_button, {
              onClick: reset,
              plain: "",
              disabled: isLoading.value
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("action.clear")), 1)
              ]),
              _: 1
            }, 8, ["disabled"]),
            _createVNode(_component_el_button, {
              type: "success",
              onClick: openWalletExportModal,
              plain: "",
              disabled: isLoading.value
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("action.export")), 1)
              ]),
              _: 1
            }, 8, ["disabled"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("table", _hoisted_18, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", _hoisted_19, [
              _createElementVNode("th", _hoisted_20, _toDisplayString(_ctx.$t("fields.id")), 1),
              _createElementVNode("th", _hoisted_21, _toDisplayString(_ctx.$t("fields.client")), 1),
              _createElementVNode("th", _hoisted_22, _toDisplayString(_ctx.$t("fields.currency")), 1),
              _createElementVNode("th", _hoisted_23, _toDisplayString(_ctx.$t("fields.fundType")), 1),
              _createElementVNode("th", _hoisted_24, _toDisplayString(_ctx.$t("fields.balance")), 1),
              _createElementVNode("th", _hoisted_25, _toDisplayString(_ctx.$t("action.action")), 1)
            ])
          ]),
          (isLoading.value)
            ? (_openBlock(), _createElementBlock("tbody", _hoisted_26, [
                _createVNode(_component_LoadingRing)
              ]))
            : (!isLoading.value && wallets.value.length === 0)
              ? (_openBlock(), _createElementBlock("tbody", _hoisted_27, [
                  _createVNode(_component_NoDataBox)
                ]))
              : (_openBlock(), _createElementBlock("tbody", _hoisted_28, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(wallets.value, (item, index) => {
                    return (_openBlock(), _createElementBlock("tr", { key: index }, [
                      _createElementVNode("td", null, _toDisplayString(item.id), 1),
                      _createElementVNode("td", _hoisted_29, [
                        (item.user)
                          ? (_openBlock(), _createBlock(_component_UserInfo, {
                              key: 0,
                              user: item.user,
                              isAdmin: 
                  item.user.isAdmin == undefined ? false : item.user.isAdmin
                ,
                              class: "me-2"
                            }, null, 8, ["user", "isAdmin"]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("td", null, _toDisplayString(_ctx.$t(`type.currency.${item.currencyId}`)), 1),
                      _createElementVNode("td", null, [
                        _createTextVNode(_toDisplayString(_ctx.$t(`type.fundType.${item.fundType}`)) + " ", 1),
                        _createVNode(_component_el_button, {
                          type: "primary",
                          size: "small",
                          class: "ms-1",
                          plain: "",
                          icon: _unref(Wallet),
                          circle: "",
                          disabled: isLoading.value,
                          onClick: ($event: any) => (changeFundType(item))
                        }, null, 8, ["icon", "disabled", "onClick"])
                      ]),
                      _createElementVNode("td", null, [
                        _createVNode(_component_BalanceShow, {
                          "currency-id": item.currencyId,
                          balance: item.balance
                        }, null, 8, ["currency-id", "balance"])
                      ]),
                      _createElementVNode("td", _hoisted_30, [
                        _createVNode(_component_el_button, {
                          onClick: ($event: any) => (viewWalletTransactions(item.id, item.currencyId)),
                          disabled: isLoading.value
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t(`action.viewTransactions`)), 1)
                          ]),
                          _: 2
                        }, 1032, ["onClick", "disabled"]),
                        _createVNode(_component_el_button, {
                          type: "success",
                          onClick: ($event: any) => (showCreateRefund(item.id)),
                          disabled: isLoading.value
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t("action.createRefund")), 1)
                          ]),
                          _: 2
                        }, 1032, ["onClick", "disabled"])
                      ])
                    ]))
                  }), 128))
                ]))
        ]),
        _createVNode(TableFooter, {
          onPageChange: fetchData,
          criteria: criteria.value
        }, null, 8, ["criteria"])
      ]),
      _createVNode(WalletExportModal, {
        ref_key: "walletExportModalRef",
        ref: walletExportModalRef
      }, null, 512),
      _createVNode(WalletDetail, {
        ref_key: "walletDetailRef",
        ref: walletDetailRef
      }, null, 512),
      _createVNode(CreateRefund, {
        ref_key: "createRefundRef",
        ref: createRefundRef,
        onEventSubmit: _cache[6] || (_cache[6] = ($event: any) => (fetchData(1)))
      }, null, 512),
      _createVNode(ChangeWalletFundType, {
        ref_key: "changeWalletFundTypeRef",
        ref: changeWalletFundTypeRef,
        onEventSubmit: _cache[7] || (_cache[7] = ($event: any) => (fetchData(1)))
      }, null, 512)
    ])
  ], 64))
}
}

})